import { createContext, type Context } from 'react';

import type { AgentSession } from '@atlassian/agent-sessions/types';

/** Presentation-only data supplied once by the navigation owner; rows never fetch sessions. */
export type NavigationAgentSession = Pick<
	AgentSession,
	'state' | 'conversationChannel' | 'displayAgent' | 'lastStateChangeAt' | 'contexts'
>;

export const NavigationAgentSessionsContext: Context<ReadonlyMap<string, NavigationAgentSession>> =
	createContext<ReadonlyMap<string, NavigationAgentSession>>(new Map());
